import { ERROR_TOAST, SUCCESS_TOAST } from "../../constants/toast.constants";
import {
  EMPTY_STRING,
  globalConstants,
  subscriptionConstants,
} from "../../constants";
import { custom, success } from "./utilities";
import { customToast } from "../../shared/utility";
import { subscriptionService } from "../../services";
import { authActions } from "../actions/auth.actions";

const {
  SUBSCRIBE,
  CHANGE_CARD,
  GET_ALL_PLANS,
  GET_SUBSCRIPTIONS,
  CANCEL_SUBSCRIPTION,
  GET_SUBSCRIPTION_PLANS,
  GET_USER_SUBSCRIPTION_STATUS,
  FETCH_INVOICE,
} = subscriptionConstants;

const getSubscriptionPlans = (roleId) => (dispatch) => {
  dispatch(custom(GET_SUBSCRIPTION_PLANS, globalConstants.SPINNER_ACTIVATE));
  return subscriptionService
    .getSubscriptionPlans(roleId)
    .then(
      (response) => {
        dispatch(success(response.data, GET_SUBSCRIPTION_PLANS));
      },
      (error) => {
        customToast(error[0], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(
        custom(GET_SUBSCRIPTION_PLANS, globalConstants.SPINNER_DIACTIVATE)
      )
    );
};

const subscribe = (id) => (dispatch) => {
  dispatch(custom(SUBSCRIBE, globalConstants.SPINNER_ACTIVATE));
  return subscriptionService
    .subscribe(id)
    .then(
      (response) => {
        dispatch(success(response.data, SUBSCRIBE));
      },
      (error) => {
        customToast(error[0], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(SUBSCRIBE, globalConstants.SPINNER_DIACTIVATE))
    );
};

// Action to reset token
const resetToken = () => {
  return (dispatch) => {
    dispatch(success(EMPTY_STRING, SUBSCRIBE));
  };
};

const getSubscriptions =
  (roleId, isSpinnerEnabled = true) =>
  (dispatch) => {
    if (isSpinnerEnabled) {
      dispatch(custom(GET_SUBSCRIPTIONS, globalConstants.SPINNER_ACTIVATE));
    }
    return subscriptionService
      .getSubscriptions(roleId)
      .then(
        (response) => {
          dispatch(success(response.data, GET_SUBSCRIPTIONS));
        },
        (error) => {
          customToast(error[0], ERROR_TOAST);
        }
      )
      .finally(() => {
        if (isSpinnerEnabled) {
          dispatch(
            custom(GET_SUBSCRIPTIONS, globalConstants.SPINNER_DIACTIVATE)
          );
        }
      });
  };

const cancelSubscription = (roleId, func) => (dispatch) => {
  dispatch(custom(CANCEL_SUBSCRIPTION, globalConstants.SPINNER_ACTIVATE));
  return subscriptionService
    .cancelSubscription(roleId)
    .then(
      (response) => {
        func();
        customToast(response.msg, SUCCESS_TOAST);
        dispatch(getSubscriptions(roleId));
      },
      (error) => {
        customToast(error[0], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(CANCEL_SUBSCRIPTION, globalConstants.SPINNER_DIACTIVATE))
    );
};

const changeCard = (roleId) => (dispatch) => {
  dispatch(custom(CHANGE_CARD, globalConstants.SPINNER_ACTIVATE));
  return subscriptionService
    .changeCard(roleId)
    .then(
      (response) => {
        dispatch(success(response.data, CHANGE_CARD));
      },
      (error) => {
        customToast(error[0], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(CHANGE_CARD, globalConstants.SPINNER_DIACTIVATE))
    );
};

const fetchInvoice = (id, body) => (dispatch) => {
  dispatch(custom(FETCH_INVOICE, globalConstants.SPINNER_ACTIVATE));
  return subscriptionService
    .getInvoice(id, body)
    .then(
      (response) => {
        dispatch(success(response.data, FETCH_INVOICE));
        return response;
      },
      (error) => {
        customToast(error[0], ERROR_TOAST);
      }
    )
    .finally(() =>
      dispatch(custom(FETCH_INVOICE, globalConstants.SPINNER_DIACTIVATE))
    );
};

const getUserSubscriptionStatus =
  (roleId, isNavigateToDefault, isSpinnerEnabled = true) =>
  (dispatch) => {
    if (isSpinnerEnabled) {
      dispatch(
        custom(GET_USER_SUBSCRIPTION_STATUS, globalConstants.SPINNER_ACTIVATE)
      );
    }
    return subscriptionService
      .getUserSubscriptionStatus(roleId)
      .then(
        (response) => {
          dispatch(success(response.data, GET_USER_SUBSCRIPTION_STATUS));
          if (isNavigateToDefault) {
            dispatch(authActions.setIsNavigateToDefault(isNavigateToDefault));
          }
        },
        (error) => {
          customToast(error[0], ERROR_TOAST);
        }
      )
      .finally(() => {
        if (isSpinnerEnabled) {
          dispatch(
            custom(
              GET_USER_SUBSCRIPTION_STATUS,
              globalConstants.SPINNER_DIACTIVATE
            )
          );
        }
      });
  };

const getAllSubscriptionPlans = () => {
  return (dispatch) => {
    dispatch(custom(GET_ALL_PLANS, globalConstants.SPINNER_ACTIVATE));
    subscriptionService
      .getAllSubscriptionPlans()
      .then(
        (response) => {
          dispatch(success(response.data, GET_ALL_PLANS));
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(custom(GET_ALL_PLANS, globalConstants.SPINNER_DIACTIVATE))
      );
  };
};

const updateAllSubscriptionPlans = (data, successFunc) => {
  return (dispatch) => {
    dispatch(custom(GET_ALL_PLANS, globalConstants.SPINNER_ACTIVATE));
    subscriptionService
      .updateAllSubscriptionPlans(data)
      .then(
        (response) => {
          successFunc();
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(custom(GET_ALL_PLANS, globalConstants.SPINNER_DIACTIVATE))
      );
  };
};

export const subscriptionActions = {
  subscribe,
  resetToken,
  changeCard,
  getSubscriptions,
  cancelSubscription,
  getSubscriptionPlans,
  fetchInvoice,
  getAllSubscriptionPlans,
  getUserSubscriptionStatus,
  updateAllSubscriptionPlans,
};
